// A prepared first message for the chat, staged by another surface.
//
// The findings review turns an open question into a chat the analyst can run:
// it stages the seed here and the chat console drains it into a fresh chat's
// composer. Nothing is sent until the analyst presses Send, so the seed stays
// editable and no inference happens on the click. One seed at a time; a new
// stage replaces an undrained one.
let pending = null;
const subscribers = new Set();

function notify() {
    subscribers.forEach((fn) => fn());
}

export function stageChatSeed({ text, label = "" }) {
    if (!text || !String(text).trim()) throw new Error("A chat seed needs text.");
    pending = { text: String(text), label: String(label || ""), stagedAt: Date.now() };
    notify();
    return pending;
}

export function peekChatSeed() {
    return pending;
}

export function takeChatSeed() {
    const seed = pending;
    pending = null;
    return seed;
}

export function subscribeChatSeed(fn) {
    subscribers.add(fn);
    return () => subscribers.delete(fn);
}

export function resetChatSeedForTests() {
    pending = null;
    subscribers.clear();
}
